module.exports = __webpack_public_path__ + "public/images/Illustration_Swimming_200x200-Color.a877629db987419aefbf393bcc273a57.png";